export const environment = {
  production: false,
  apiBaseUrl: 'https://api.poc-ws3.org',
  sameSiteLabel: 'poc-ws3.org',
  crossSiteLabel: 'onrender.com',
  crossSiteHostnames: ['samesite-front.onrender.com']
} as const;
